import * as actionTypes from '../actionTypes'
import api from '../api'
import { insert as insertOtherAccounts } from '../database/otherAccounts.js'
import { insert as insertPoPreferences } from '../database/poPreferences.js'
import { insert as insertLbbPoPreferences } from '../database/lbb/poPreferences.js'
import { persist as persistTires } from '../database/tirePreferences.js'
import { persist as persistWheels } from '../database/wheelPreferences.js'
import { persist as persistLbbTires } from '../database/lbb/tirePreference.js'
import { persist as persistLbbWheels } from '../database/lbb/wheelPreference.js'
import { insert as updateDispErsCommentsAndAuth } from '../database/misc.js'
import { insert as updateLbbDispErsCommentsAndAuth } from '../database/lbb/misc.js'
import { persist as persistContacts } from '../database/contacts'
import { loadPref } from './formDialogActions'
import { persist as persistLbbContacts } from '../database/lbb/contacts.js'

/*eslint radix: ["error", "as-needed"]*/

const startingSave = () => ({
	type: 'STARTING_SAVE'
})

const failedSave = (message) => ({
	type: 'SAVE_ERROR',
	message: message
})

export const snackClose = () => {
	return async (dispatch, getState) => {
		dispatch({ type: 'SNACK_CLOSE' })
	}
}

export const save = () => {
	return async (dispatch, getState) => {
		//check for errors
		let state = getState()
		const tires = state.homePage.tires
		let fail = false
		let errorMessage

		let uniqBy = require('lodash.uniqby')

		const filteredTires = tires.filter(t => !t.readOnly && !t.isDelete)

		const axleTypes = uniqBy(filteredTires.map(t => { return { axleType: t.axleType } }), 'axleType')
		const applications = uniqBy(filteredTires.map(t => { return { application: t.application } }), 'application')
		const tireSizes = uniqBy(filteredTires.map(t => { return { tireSize: t.tireSize } }), 'tireSize')

		for (let axle of axleTypes) {
			const tiresByAxle = filteredTires.filter(t => parseInt(t.axleType) === parseInt(axle.axleType))

			for (let application of applications) {
				const tiresByApplicationAndAxle = tiresByAxle.filter(t => parseInt(t.application) === parseInt(application.application))

				for (let tireSize of tireSizes) {
					const tiresByAxleApplicationAndSize = tiresByApplicationAndAxle
						.filter(t => parseInt(t.tireSize) === parseInt(tireSize.tireSize))
						.sort(function (a, b) {
							const ap = parseInt(a.priority)
							const bp = parseInt(b.priority)

							if (ap < bp) return -1
							if (ap > bp) return 1

							return 0
						})

					let i = 1
					for (let tire of tiresByAxleApplicationAndSize) {
						if (i !== parseInt(tire.priority)) {

							fail = true
							errorMessage = 'When prioritizing tire preferences based on axle type, application and tire size, the priority must be numbered sequentially, starting at 1'
							break
						}
						i++
					}
				}
			}
		}

		if (!state.homePage.driverAuthorization) {
			errorMessage = 'Please select a driver authorization'
			fail = true
		}

		if (fail) {
			dispatch(failedSave(errorMessage))
			return
		}
		
		dispatch(startingSave())

		let locationId = state.homePage.homePageDomain.id


		//update
		let load
		try {
			if (locationId && !state.homePage.lbbFlag) { 

				await persistContacts(state.homePage.contact, state.homePage.homePageDomain, locationId, state.homePage.contactTypes)
				await insertPoPreferences(state.homePage.poPreference, state.homePage.homePageDomain, state.homePage.lbbFlag, state.homePage.country, state.homePage.isBillTo)

				await persistTires(state.homePage.tires, state.homePage, locationId, state.homePage.isBillTo)
				await persistWheels(state.homePage.wheels, state.homePage, locationId, state.homePage.isBillTo)
				await updateDispErsCommentsAndAuth(locationId, state.homePage.homePageDomain.fleetId, state.homePage.driverAuthorization, state.homePage.disposition, state.homePage.ersInstructions)
				// if (response.data[0].accountType.name === 'NAFA') {

				await insertOtherAccounts(state.homePage.otherAccountNumbers, locationId, state.homePage.isBillTo)
				load = loadPref(locationId, false)
			} else {
				await persistLbbContacts(state.homePage.contact, locationId, state.homePage.contactTypes)
				await insertLbbPoPreferences(state.homePage.poPreference, state.homePage.homePageDomain)

				await persistLbbTires(state.homePage.tires, state.homePage, locationId)
				await persistLbbWheels(state.homePage.wheels, state.homePage, locationId)
				await updateLbbDispErsCommentsAndAuth(locationId, state.homePage.driverAuthorization, state.homePage.disposition, state.homePage.ersInstructions)

				load = loadPref(locationId, true)
			}
		} catch (error) {
			await dispatch(failedSave('Save did not work'))
			return
		}
		//await dispatch({ type: actionTypes.HOMEPAGE_SAVE })

		await load(dispatch, getState)
	}
}

export const cancel = (profile) => {
	return async (dispatch, getState) => {
		dispatch({ type: actionTypes.HOMEPAGE_CANCEL })
	}
}

export const accountChangeValue = (event) => {
	return async (dispatch, getState) => {
		dispatch(accountChange(event.target.name, event.target.value))
	}
}

export const accountChangeValueOld = (event) => {
	return async (dispatch, getState) => {
		dispatch(accountChangeOld(event.target.name, event.target.value))
	}
}

export const accountChange = (field, value) => ({
	type: actionTypes.ACCOUNT_CHANGE,
	value: value,
	field: field
})

export const accountChangeOld = (field, value) => ({
	type: actionTypes.ACCOUNT_CHANGE_OLD,
	value: value,
	field: field
})

export const addressChange = (address) => {
	return async (dispatch, getState) => {
		dispatch(addressChangeAction(address))
	}
} 

const addressChangeAction = (address) => ({
	type: actionTypes.ADDRESS_CHANGE,
	address: address
})

export const accountEdit = (accountNumber, accountName) => {
	return async (dispatch, getState) => {
		dispatch(accountEditAction(accountNumber, accountName))
	}
}

const accountEditAction = (accountNumber, accountName) => ({
	type: actionTypes.ACCOUNT_EDIT,
	accountNumber: accountNumber,
	accountName: accountName,
})

class Option {
	constructor(id, val) {
		this.id = id
		this.name = val
	}
}

export const lbbSearch = (lbbAccountNumber) => {
	return async dispatch => {

		try {
			let response = await api.service('locations').find({
				query: {
					account_id: {
						$eq: lbbAccountNumber
					},
					is_bill_to: {
						$eq: true
					}
				}
			})
			let dropdown = response.data.reduce((btNumbers, location) => {
				btNumbers.push(new Option(location.accountNumber, location.accountNumber))
				return btNumbers
			}, [])
			dispatch(lbb_search_action(dropdown))
		} catch (error) {
			//catch an error here
		}
	}
}

const lbb_search_action = lbbAccountNumber => ({
	type: actionTypes.LBB_SEARCH,
	options: lbbAccountNumber
})

export const handleDomainChangeValue = (event) => {
	return async (dispatch, getState) => {
		dispatch(domainChangeAction(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

const domainChangeAction = (name, value) => ({
	type: actionTypes.DOMAIN_CHANGE,
	field: name,
	value: value
})

export const poRequiredChange = (event) => {
	return async (dispatch, getState) => { 
		dispatch(poRequiredChangeAction(event.target.name, event.target.type === 'radio' ? event.target.value === "true" : event.target.value))
	}
}

const poRequiredChangeAction = (name, value) => ({
	type: actionTypes.PO_REQUIRED_CHANGE_ACTION,
	name: name,
	value: value  
})

export const ccRequiredChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(ccRequiredChangeAction(event.target.name, event.target.value))
	}
}

const ccRequiredChangeAction = (name, value) => ({
	type: actionTypes.CC_REQUIRED_CHANGE_ACTION,
	name: name,
	value: value
})

export const handleContactChangeValue = (event) => {
	return async (dispatch, getState) => {
		dispatch(contactChange(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

export const contactChange = (name, value) => ({
	type: actionTypes.CONTACT_CHANGE,
	name: name,
	value: value
})

export const handleContactChangeValueSelect = (event) => {
	return async (dispatch, getState) => {
		dispatch(contactChangeSelect(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

export const contactChangeSelect = (name, value) => ({
	type: actionTypes.CONTACT_CHANGE_SELECT,
	name: name,
	value: value
})

export const addContact = () => {
	return async (dispatch, getState) => {
		dispatch(addContactEvent())
	}
}

export const addContactEvent = () => ({
	type: actionTypes.ADD_CONTACT
})


export const removeContact = (index) => {
	return async (dispatch, getState) => {
		dispatch(removeContactEvent(index))
	}
}

export const removeContactEvent = (index) => ({
	type: actionTypes.REMOVE_CONTACT,
	index: index
})

export const handlePoPreferenceChangeValue = (event) => {
	return async (dispatch, getState) => {
		dispatch(poPreferenceChange(event.target.name, event.target.value))
	}
}

export const poPreferenceChange = (name, value) => ({
	type: actionTypes.PO_PREFERENCE_CHANGE,
	name: name,
	value: value
})

export const addPoPreference = () => {
	return async (dispatch, getState) => {
		dispatch(addPoPreferenceEvent())
	}
}

export const addPoPreferenceEvent = () => ({
	type: actionTypes.ADD_PO_PREFERENCE
})

export const removePoPreference = (index) => {
	return async (dispatch, getState) => {
		dispatch(removePoPreferenceEvent(index))
	}
}

export const removePoPreferenceEvent = (index) => ({
	type: actionTypes.REMOVE_PO_PREFERENCE,
	index: index
})

export const handleAccountNumbersChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(accountNumbersChange(event.target.name, event.target.value))
	}
}

export const accountNumbersChange = (name, value) => ({
	type: actionTypes.ACCOUNT_NUMBERS_CHANGE,
	name: name,
	value: value
})

export const handleAccountNumbersChangeSelect = (event) => {
	return async (dispatch, getState) => {
		dispatch(accountNumbersChangeSelect(event.target.name, event.target.value))
	}
}

export const accountNumbersChangeSelect = (name, value) => ({
	type: actionTypes.ACCOUNT_NUMBERS_CHANGE_SELECT,
	name: name,
	value: value
})

export const addOtherAccountNumbers = () => {
	return async (dispatch, getState) => {
		dispatch(addOtherAccountNumbersEvent())
	}
}

export const addOtherAccountNumbersEvent = () => ({
	type: actionTypes.ADD_ACCOUNT_NUMBERS
})

export const removeOtherAccountNumbers = (index) => {
	return async (dispatch, getState) => {
		dispatch(removeOtherAccountNumbersEvent(index))
	}
}

export const removeOtherAccountNumbersEvent = (index) => ({
	type: actionTypes.REMOVE_ACCOUNT_NUMBERS,
	index: index
})


export const handleNotificationChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(handleNotificationChangeAction(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value))
	}
}

export const handleNotificationChangeAction = (name, value) => ({
	type: actionTypes.NOTIFICATION_CHANGE,
	name: name,
	value: value
})

export const addNotification = () => {
	return async (dispatch, getState) => {
		dispatch(addNotificationAction())
	}
}

export const addNotificationAction = () => ({
	type: actionTypes.ADD_NOTIFICATION
})

export const removeNotification = (index) => {
	return async (dispatch, getState) => {
		dispatch(removeNotificationAction(index))
	}
}

export const removeNotificationAction = (index) => ({
	type: actionTypes.REMOVE_NOTIFICATION,
	index: index
})


//wheel
export const wheelChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(wheelChangeAction(event.target.name, event.target.value))
	}
}

export const wheelChangeAction = (name, value) => ({
	type: actionTypes.WHEEL_CHANGE,
	name: name,
	value: value
})

export const wheelChangeSelect = (event) => {
	return async (dispatch, getState) => {
		dispatch(wheelChangeActionSelect(event.target.name, event.target.value))
	}
}

export const wheelChangeActionSelect = (name, value) => ({
	type: actionTypes.WHEEL_CHANGE_SELECT,
	name: name,
	value: value
})

export const addWheel = () => {
	return async (dispatch, getState) => {
		let state = getState().homePage
		dispatch(addWheelEvent(state.wheelDiameterOptions[0].id, state.wheelOffsetOptions[0].id,
			state.wheelMaterialTypeOptions[0].id, state.wheelTypeOptions[0].id))
	}
}

export const addWheelEvent = (wheelDiameter, wheelOffset, wheelMaterial, wheelType) => ({
	type: actionTypes.ADD_WHEEL,
	wheelDiameter: wheelDiameter,
	wheelOffset: wheelOffset,
	wheelMaterial: wheelMaterial,
	wheelType: wheelType
})

export const removeWheel = (index) => {
	return async (dispatch, getState) => {
		dispatch(removeWheelAction(index))
	}
}

export const removeWheelAction = (index) => ({
	type: actionTypes.REMOVE_WHEEL,
	index: index
})
//tire
export const tireChange = (event) => {
	return async (dispatch, getState) => {
		dispatch(tireChangeAction(event.target.name, event.target.value))
	}
}

export const tireChangeAction = (name, value) => ({
	type: actionTypes.TIRE_CHANGE,
	name: name,
	value: value
})

export const tireChangeSelect = (event) => {
	return async (dispatch, getState) => {
		dispatch(tireChangeActionSelect(event.target.name, event.target.value))
	}
}

export const tireChangeActionSelect = (name, value) => ({
	type: actionTypes.TIRE_CHANGE_SELECT,
	name: name,
	value: value
})

export const addTire = () => {
	return async (dispatch, getState) => {
		let state = getState().homePage
		dispatch(addTireWheel(
			state.axleTypeOptions.filter(item => item.name === 'Steer')[0].id, 
			state.tireApplicationTypeOptions.filter(item => item.applicationCode === 'NS')[0].applicationId,
			false, 
			-1,
			-1, 
			-1,
			-1, 
			state.requiredActivityTypeOptions.filter(item => item.name === 'Await Verbal Instruction')[0].id,
			state.accountType === 'NAFA' ? state.homePageDomain.id : null))
	}
}

export const addTireWheel = (axleType, tireApplicationId, tireType, tireBrand, tireSize, tread, loadRange, requiredActivity, fleetLocationId) => ({
	type: actionTypes.ADD_TIRE,
	axleType: axleType,
	tireApplicationId: tireApplicationId,
	tireType: tireType,
	tireBrand: tireBrand,
	tireSize: tireSize,
	tread: tread,
	loadRange: loadRange,
	requiredActivity: requiredActivity,
	fleetLocationId: fleetLocationId
})

export const removeTire = (index) => {
	return async (dispatch, getState) => {
		dispatch(removeTireAction(index))
	}
}

export const removeTireAction = (index) => ({
	type: actionTypes.REMOVE_TIRE,
	index: index
})

export const duplicateTire = (tire) => {
	return async (dispatch, getState) => {
		let state = getState().homePage
		
		dispatch(addTireWheel(
			tire.axleType, 
			tire.application,
			tire.tireType,
			tire.tireBrand,
			tire.tireSize,
			tire.tread,
			tire.loadRange,
			tire.requiredActivity,
			state.accountType === 'NAFA' ? state.homePageDomain.id : null))
	}
}



// WEBPACK FOOTER //
// ./src/actions/homePage.js